export const getMarkLabel = (mark) => {
  if (!mark) return '';

  return mark?.split(':')?.slice(0, 1);
};
